module.exports = __webpack_public_path__ + "img/legendary.13f20f9e.png";